import { lazy } from 'react';

export const MedOrgsPage = lazy(() => import('./MedOrgsPage'));
